import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import Autocomplete from 'react-autocomplete'

import ls from 'local-storage'
import cx from 'classnames'

import hocConnect from './hocConnect'

import { LOCALE_PREFIX, ENTER_KEY_CODE } from './constants'

import './style.scss'

@hocConnect
@injectIntl
export default class SearchBar extends Component {
    static propTypes = {
        entitySearchStart: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        searchIndex: PropTypes.string.isRequired,
        searching: PropTypes.bool.isRequired,
        searchValue: PropTypes.string.isRequired,
        socketEntitySearchStart: PropTypes.func.isRequired,
    }

    constructor(props) {
        super()
        const { searchValue, searchIndex } = props

        this.state = {
            searchValue,
            autocompleteValues: this.getAutocompleteValues(searchIndex),
        }
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { searching: nextSearching, searchValue } = nextProps
        const { searching, searchIndex } = this.props

        if (searching && !nextSearching) {
            this.setState({ autocompleteValues: this.getAutocompleteValues(searchIndex) })
        }

        if (this.state.searchValue !== searchValue) {
            this.setState({ searchValue })
        }
    }

    getAutocompleteValues = (searchIndex) => {
        let nextAutocompleteValues = ls.get(searchIndex) || []
        nextAutocompleteValues = nextAutocompleteValues.map(({ searchValue }) => ({ searchValue }))
        nextAutocompleteValues.splice(0, 0, { searchValue: '', isFirst: true })

        return nextAutocompleteValues
    }

    getItemValue = (item) => item.searchValue

    handleOnSearch = () => {
        const { entitySearchStart, searching, searchValue: searchedValue, socketEntitySearchStart } = this.props
        const { searchValue } = this.state

        if (!searching && searchValue && searchValue !== searchedValue) {
            entitySearchStart(searchValue)
            socketEntitySearchStart(searchValue)
            this.setState({ searchValue })
        }
    }

    handleOnSearchChange = (_event) => {
        const {
            target: { value: searchValue },
        } = _event
        const { searching } = this.props

        if (!searching) {
            this.setState({ searchValue })
        }
    }

    handleOnSearchSelect = (searchValue) => {
        const { entitySearchStart, searching, searchValue: searchedValue, socketEntitySearchStart } = this.props

        if (!searching && searchValue && searchValue !== searchedValue) {
            entitySearchStart(searchValue)
            socketEntitySearchStart(searchValue)
            this.setState({ searchValue })
        }
    }

    handleOnKeyDown = (_event) => {
        const { keyCode, which } = _event
        const { entitySearchStart, searching, searchValue: searchedValue, socketEntitySearchStart } = this.props
        const { searchValue } = this.state

        if (
            (keyCode === ENTER_KEY_CODE || which === ENTER_KEY_CODE) &&
            !searching &&
            searchValue &&
            searchValue !== searchedValue
        ) {
            entitySearchStart(searchValue)
            socketEntitySearchStart(searchValue)
            this.setState({ searchValue })
        }
    }

    renderAutocompleteItem = (item) => {
        const { searchValue, isFirst } = item
        const {
            intl: { formatMessage },
        } = this.props

        return (
            <div key={searchValue} className={cx('autocomplete-field', { 'first-item': isFirst })}>
                <span>{isFirst ? formatMessage({ id: `${LOCALE_PREFIX}.searchAutocompleteTitle` }) : searchValue}</span>
            </div>
        )
    }

    render() {
        const { searchValue, autocompleteValues } = this.state
        const {
            intl: { formatMessage },
        } = this.props

        return (
            <div className={cx('entity-stack-search-bar')}>
                <Autocomplete
                    getItemValue={this.getItemValue}
                    items={autocompleteValues}
                    renderItem={this.renderAutocompleteItem}
                    value={searchValue}
                    onChange={this.handleOnSearchChange}
                    onSelect={this.handleOnSearchSelect}
                    inputProps={{
                        placeholder: formatMessage({ id: `${LOCALE_PREFIX}.placeholder` }),
                        onKeyDown: this.handleOnKeyDown,
                    }}
                />
                <div className={'search-button'} onClick={this.handleOnSearch} />
            </div>
        )
    }
}
